import React from 'react';
import ProfileGenerique from '../profile/ProfileGenerique';

export default function ProfileChargeLogement() {
    return <ProfileGenerique role="charge_logements" title="🏢 Mon profil logement" color="from-green-600 to-teal-600" />;
}